<template>
  <div class="number-input">
    <button @click="decrease">-</button>
    <input
        type="number"
        step="1"
        min="0"
        :value="value"
        @input="onInput"
        @keydown="onKeydown"
    />
    <button @click="increase">+</button>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    value: { type: Number, default: 0 },
  },
  methods: {
    increase () {
      this.emitValue(this.value + 1)
    },
    decrease () {
      this.emitValue(Math.max(this.value - 1, 0))
    },
    onInput (e) {
      const value = e.target.value

      if (value.length === 0) {
        return false
      }

      this.emitValue(value)
    },
    onKeydown(e) {
      if (['0','1','2','3','4','5','6','7','8','9', 'Backspace', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        return true
      } else {
        e.stopPropagation()
        e.preventDefault()

        return false
      }
    },
    emitValue (newValue) {
      this.$emit('input', parseInt(newValue))
    },
  },
}
</script>

